import { SlbBannerCard } from "app/utils/interfaces/slb-banner-card.interface";

export const subsurfaceCardsDistribution: SlbBannerCard[] = [
  { titleRef: 'Section31A', contentRef: 'Section31C', imageRef: 'Section31D', subtitleRef: 'Section31B' },
  { titleRef: 'Section32A', contentRef: 'Section32C', imageRef: 'Section32D', subtitleRef: 'Section32B' },
  { titleRef: 'Section33A', contentRef: 'Section33C', imageRef: 'Section33D', subtitleRef: 'Section33B' },
  { titleRef: 'Section34A', contentRef: 'Section34C', imageRef: 'Section34D', subtitleRef: 'Section34B' },
  { titleRef: 'Section35A', contentRef: 'Section35C', imageRef: 'Section35D', subtitleRef: 'Section35B' },
  { titleRef: 'Section36A', contentRef: 'Section36C', imageRef: 'Section36D', subtitleRef: 'Section36B' },
];
export const Marketing3PageLayout = {
    slots: ['Section2', 'SlbUseCasesMainSlot', 'SlbUseCasesCardsSlot' , 'SlbBlueBottomBannerSlot'],
};
  